module.exports = __webpack_public_path__ + "img/Monte_Kope_42.34b6001f.jpg";